import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import moment from 'moment';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {find, get, keyBy} from 'lodash';
import {GeneralConfigService, AlertService, TokenStorage, RouteService, MakeCallService, DataStorageService, Credential, AuthenticateService, LoaderService, CustomValidatorsService, SessionRefreshService} from "foo-framework";

@Component({
  selector: 'app-self-onboarding-signup',
  templateUrl: './self-onboarding-signup.component.html',
  styleUrls: ['./self-onboarding-signup.component.scss'],
  providers: [SessionRefreshService]
})
export class SelfOnboardingSignupComponent implements OnInit {

  curLang: string;
  hasSymbols = false;
  hasNumbers = false;
  hasLowercase = false;
  hasUppercase = false;
  hasLength = false;
  //rememberMe is added for later use(like in login component)
  signupForm = new UntypedFormGroup({
    username: new UntypedFormControl('', [Validators.required, this.customValidators.email]),
    new_pin: new UntypedFormControl('', [Validators.required]),
    repeat_new_pin: new UntypedFormControl('', [Validators.required]),
    rememberMe: new UntypedFormControl(''),
  });
  @Output() LangChangedEvent = new EventEmitter<string>();
  credentials: Credential;

  code: string;
  type: string;
  configuration = JSON.parse(window['configuration']);
  logo = this.configuration && this.configuration['login_logo'] ? this.configuration['login_logo'] : this.configuration['logo'];
  pagetitle = this.configuration ? this.configuration['title'] :'';
  passConfig: any;
  charNumber =  0;
  currentYear = moment().year();
  showLang = false;
  isrtl = false;
  btntitle = 'auth.onboarding.signup';
  selfOnboardingCategoryKey;

  projectName = '';
  recaptchaEnabled: boolean = !!window['google_recaptcha_guest'];
  showCopyright;
  showDesignedDevelopedByFoo;
  public constructor(
    protected sessionRefreshService: SessionRefreshService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected DataStorage: DataStorageService,
    protected authenticateService: AuthenticateService,
    protected makecall: MakeCallService,
    protected routesService: RouteService,
    protected tokenStorage: TokenStorage,
    protected alert: AlertService,
    protected route: ActivatedRoute,
    protected translate: TranslateService,
    protected generalConfigService: GeneralConfigService,
    protected customValidators: CustomValidatorsService,
    protected loaderService: LoaderService) {
    translate.setDefaultLang(this.tokenStorage.getCurrentLanguage());
  }


  ngOnInit(): void {
    const showCopyrightVal = this.generalConfigService.getConfigProperty('commonConfig')?.showCopyright;
    this.showCopyright = showCopyrightVal !== undefined ? showCopyrightVal : true;
    const showDesignedDevelopedByFooVal = this.generalConfigService.getConfigProperty('commonConfig')?.showDesignedDevelopedByFoo;
    this.showDesignedDevelopedByFoo = showDesignedDevelopedByFooVal !== undefined ? showDesignedDevelopedByFooVal : true;

    document.body.classList.remove('login-page-template');

    if (this.tokenStorage.getUser() && this.tokenStorage.getUser() !== 'undefined' && this.tokenStorage.getUser() !== 'null') {
      if (!this.selfOnboardingCategoryKey) {
        this.tokenStorage.clear();
        const userconf = window['userconfig'] ? JSON.parse(window['userconfig']) : [];
        if (get(userconf, 'default_state')) {
          this.loaderService.visibility = false;
          this.router.navigate([get(userconf, 'default_state')]);
        } else {
          this.loaderService.visibility = false;
          this.router.navigate(['/home']);
        }
      }
    } else {
      if (this.tokenStorage.getSelfOnboardingToken()) {
        this.router.navigate(['/self-onboarding']);
      } else {
        this.tokenStorage.clear();

        this.tokenStorage.setSelfOnboardingCategoryKey();
        this.selfOnboardingCategoryKey = this.tokenStorage.getSelfOnboardingCategoryKey();
      }
    }


    this.showLang = JSON.parse(window['showlang']);
    this.curLang = this.tokenStorage.getCurrentLanguage();
    this.code = this.route.snapshot.paramMap.get('code');
    this.type = this.route.snapshot.paramMap.get('type');

    if(this.type !==null && this.type !== undefined){
      if(this.type == 'set'){
        this.pagetitle='auth.setPassword';
        this.btntitle = 'auth.setPassword';
      }
    }
    this.getPassConfig();
  }

  getPassConfig(){
    this.loaderService.visibility=true;
    this.makecall.postCall("auth/passconfig",
      {
        app_id: this.tokenStorage.getSelfOnboardingConfigAppId()
      }, null, { googleRecaptchaEnabled: this.recaptchaEnabled }
    ).subscribe(resp => {
        this.loaderService.visibility=false;
        if(resp["status"]=="OK"){
          this.passConfig = keyBy(resp['configuration'], 'key');
          this.charNumber = this.passConfig['password_length'] && this.passConfig['password_length'].value ? this.passConfig['password_length'].value : 0;
        }else{
          this.alert.emitAlert({type:"danger", text: resp["message"]});
        }
      },
      error=>{
        this.loaderService.visibility=false;
        this.alert.emitAlert({type:"danger", text: this.translate.instant('general.somethingWentWrong')});
        this.router.navigate(['/login']);
      });
  }
  get f() { return this.signupForm.controls; }

  allDoneExceptPasswordMismatch() {
    if ((this.f.new_pin.value != this.f.repeat_new_pin.value) && this.hasSymbols && this.hasNumbers && this.hasLowercase && this.hasUppercase && this.hasLength) {
      return true;
    }
  }

  checkPass(){
    return (this.f.new_pin.value === this.f.repeat_new_pin.value
      && this.hasSymbols
      && this.hasNumbers
      && this.hasLowercase
      && this.hasUppercase
      && this.hasLength);
  }

  passModify() {
    if (this.passConfig && this.passConfig["password_length"] && this.f.new_pin.value.length < Number(this.passConfig["password_length"].value)) {
      this.hasLength = false;
    } else {
      this.hasLength = true;
    }
    let re = new RegExp(/[-!@$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/);
    if (this.passConfig && this.passConfig["password_symbols"] && this.passConfig["password_symbols"].value == 1 && !re.test(this.f.new_pin.value)) {
      this.hasSymbols = false;
    } else {
      this.hasSymbols = true;
    }
    re = new RegExp(/[0-9]/);
    if (this.passConfig && this.passConfig["password_numbers"] && this.passConfig["password_numbers"].value == 1 && !re.test(this.f.new_pin.value)) {
      this.hasNumbers = false;
    } else {
      this.hasNumbers = true;
    }
    re = new RegExp(/[a-z]/);
    if (this.passConfig && this.passConfig["password_lowercase"] && this.passConfig["password_lowercase"].value == 1 && !re.test(this.f.new_pin.value)) {
      this.hasLowercase = false;
    } else {
      this.hasLowercase = true;
    }
    re = new RegExp(/[A-Z]/);
    if (this.passConfig && this.passConfig["password_uppercase"] && this.passConfig["password_uppercase"].value == 1 && !re.test(this.f.new_pin.value)) {
      this.hasUppercase = false;
    } else {
      this.hasUppercase = true;
    }

  }

  useLanguage() {
    var language = 'en';
    this.isrtl = false;
    if (this.tokenStorage.getCurrentLanguage() == 'en') {
      language = 'ar';
      this.isrtl = true;
    }
    this.translate.use(language);
    this.LangChangedEvent.emit(language);
    this.tokenStorage.setCurrentLanguage(language);
  }

  onSubmit() {
    if (this.signupForm.valid) {
      this.loaderService.visibility = true;

      this.credentials = {
        username: this.f.username.value,
        password: this.f.new_pin.value,
      };
      if (this.checkPass()) {

        this.authenticateService
          .signup(this.f.username.value, this.f.new_pin.value, this.tokenStorage.getSelfOnboardingConfigAppId(), this.f.rememberMe.value, this.recaptchaEnabled)
          .subscribe(
            (data) => {
              if (data['status'] === 'OK') {

                ///TODO: add handling for should_validate
                this.routesService.routesHistory = [];
                if (data['should_validate']) {
                  this.DataStorage.storage = {
                    email: this?.f?.username?.value ? this.f.username.value : '',
                    token: data?.code,
                    route: '/home',
                    register_validation : false
                  };

                  if (data?.expireAfter) {
                    this.DataStorage.storage = {...this.DataStorage.storage, resend_counter : data.expireAfter}
                  }
                  this.router.navigate(['/login-otp']);
                }
                else {
                  if (data?.data['token']) {
                    this.tokenStorage.setSelfOnboardingToken(data?.data['token']);
                  }

                  this.router.navigate(['/self-onboarding']);
                }
              } else if (data['status'] === 'redirect') {
                if (data['redirectTo']) {
                  window.location.href = data['redirectTo'];
                }
              } else {
                this.alert.emitAlert({type: 'danger', text: data['message']});
              }
            },
            (error) => {
              this.alert.emitAlert({type: 'danger', text: error['message']});
            }
          );
      } else {
        this.loaderService.visibility = false;
        if (this.allDoneExceptPasswordMismatch()) {
          this.alert.emitAlert({type: "danger", text: this.translate.instant('auth.passwordMismatch')});
        } else {
          this.alert.emitAlert({
            type: "danger",
            text: this.translate.instant('auth.PasswordDoesNotMeetTheMinimumRequirements')
          });
        }
      }
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
